import { Typography, Select, Icon } from "@ann/web-components";
import { ContentWrapper, ContentTopWrapper, ContentBottomWrapper, ContentBottomLeftWrapper, ContentBottomRightWrapper, ContentRowWrapper, ModelSelectWrapper } from "../../ModelSelector.styled";
import VehicleInformation from "../../../../../../components/VehicleInformation/VehicleInformation";

const ModelSelectorContent = ({ hookData }) => {
    const {
        vehicleOptions,
        selectedVehicle,
        selectedValue,
        handleVehicleChange,
        loading,
    } = hookData;

    return (
        <ContentWrapper>
            <ContentTopWrapper>
                <ModelSelectWrapper>
                    <Select
                        label="Vehicle"
                        placeholder={loading ? "Loading vehicles..." : "Select a vehicle"}
                        value={selectedValue}
                        onChange={handleVehicleChange}
                        size="small"
                        width="100%"
                        disabled={loading || vehicleOptions.length === 0}
                    >
                        <Select.Menu>
                            {vehicleOptions.map(({ value, label }) => (
                                <Select.Item key={value} value={value} label={label}>
                                    {label}
                                </Select.Item>
                            ))}
                        </Select.Menu>
                    </Select>
                </ModelSelectWrapper>
                <Icon name="aiChat" size="medium" />
            </ContentTopWrapper>
            <VehicleInformation vehicle={selectedVehicle} />
        </ContentWrapper>
    );
};

export default ModelSelectorContent;
